import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Promise from 'babel-runtime/core-js/promise';

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import { getToken, getCompanyId, getCompanySetting, getDomain, Landingpage, testDomain, Loginpage, isJcbUser } from 'jcb-token-kit';
import { stringify } from 'qs';
import { dyDomainCity, dyDomainNy } from '../utils/constant';
import useCustomized from './useCustomized';

var UseDomain = function UseDomain() {
  var domainUrl = process.env.REACT_APP_JCB_ENV === 'dev' ? testDomain : Landingpage;
  console.log(process.env);

  var _useCustomized = useCustomized(),
      checkIsCustomized = _useCustomized.checkIsCustomized;
  // const token = getToken();


  var companyId = getCompanyId() || 0;
  var domain = window.location.protocol + '//' + window.location.host;

  // effect参数代表企业是否开启定制
  var getDomainByCompanyId = function getDomainByCompanyId(id, effect) {
    console.log(getCompanyId(), 'getCompanyId()');
    // 获取登录域名，根据域名判断跳转页面）
    if (effect) {
      return getCompanySetting(id).then(function (_ref) {
        var domain = _ref.domain;
        var factoryDomain = domain.factoryDomain;

        return factoryDomain || domainUrl + '/login?companyid=' + id;
      });
    }
    // if (id === 0) {
    //   return Promise.resolve(domain + '/login');
    // }
    return _Promise.resolve(domainUrl + '/login?companyid=' + id);
  };
  var gotoLoginPage = function gotoLoginPage() {
    // 如果获取不到token，则需要登录
    // token存在时，不需要考虑
    if (process.env.REACT_APP_TYPE === 'city') {
      return _Promise.resolve(dyDomainCity + '/login?companyid=' + (getCompanyId() || 0));
    }
    if (process.env.REACT_APP_TYPE === 'ny') {
      return _Promise.resolve(dyDomainNy + '/login?companyid=' + (getCompanyId() || 0));
    }
    if (!getToken()) {
      if (getCompanyId()) {
        return checkIsCustomized(getCompanyId()).then(function (v) {
          return getDomainByCompanyId(getCompanyId(), v);
        });
      } else {
        // 根据域名反查企业
        return getDomain(2, domain).then(function (_ref2) {
          var id = _ref2.id,
              effect = _ref2.effect;

          return getDomainByCompanyId(id, effect);
        });
      }
    }
  };
  var stringifyQuery = function stringifyQuery(params) {
    if (params && _JSON$stringify(params) !== '{}') {
      return '?' + stringify(params);
    }
    return '';
  };
  var getLoginDomain = function getLoginDomain() {
    var projectId = localStorage.getItem('loginProjectId');
    var loginCompanyid = localStorage.getItem('loginCompanyid');
    var urlParam = {};
    if (projectId) {
      urlParam.id = projectId;
    }
    if (loginCompanyid) {
      urlParam.companyid = loginCompanyid;
    }
    // const urlParam = projectId ? `?id=${projectId}` : '';
    return isJcbUser() || sessionStorage.getItem('login_from_jcb') ? _Promise.resolve(domain + ('/login' + stringifyQuery(urlParam))) : localStorage.getItem('isSpecial') ? getDomainByCompanyId(getCompanyId(), true) : _Promise.resolve(domainUrl + '/login?companyid=' + companyId);
  };
  var getCompanyInfo = function getCompanyInfo() {
    return getDomain(2, domain).then(function (data) {
      return data;
    });
  };

  return {
    gotoLoginPage: gotoLoginPage,
    getLoginDomain: getLoginDomain,
    getCompanyInfo: getCompanyInfo
  };
};

__signature__(UseDomain, 'useCustomized{{checkIsCustomized}}', function () {
  return [useCustomized];
});

var _default = UseDomain;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(UseDomain, 'UseDomain', 'src/components/useDomain.js');
  reactHotLoader.register(_default, 'default', 'src/components/useDomain.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();